/* FNX-PROOF-POPUP · 2026-10-13
   Prueba social propia alimentada SOLO de pedidos reales (metafield fnx.proof_feed).
   Reglas de experiencia:
   - Primera aparición tras ~16 s de pestaña visible (el reloj se pausa si se oculta).
   - Máximo 3 tarjetas por sesión; 1 visible a la vez; si el visitante cierra, no vuelve en la sesión.
   - Nunca en carrito ni checkout. En ficha móvil no arranca hasta que hay scroll (no tapa la buybar).
   - Respeta prefers-reduced-motion / html.rm. Si el feed falla, no muestra nada. */
(function () {
  'use strict';

  var path = window.location.pathname || '';
  if (/\/(cart|checkouts?|checkout)(\/|$)/.test(path)) return;

  var host = document.getElementById('fnx-proof');
  if (!host) return;

  var feedEl = host.querySelector('[data-fnx-proof-feed]');
  var feed = null;
  try {
    feed = JSON.parse(feedEl ? feedEl.textContent : 'null');
  } catch (e) {
    feed = null;
  }
  if (!Array.isArray(feed) || feed.length === 0) {
    host.remove();
    return;
  }
  feed = feed.filter(function (e) {
    return e && e.name && e.product && e.date && !isNaN(Date.parse(e.date));
  });
  if (feed.length === 0) {
    host.remove();
    return;
  }

  /* ---------- Estado por sesión (localStorage + token de sesión) ---------- */
  var LS_KEY = 'fnxProof.v1';
  var SS_KEY = 'fnxProofSid';
  var MAX_SHOWS = 3;
  var sid = null;
  try {
    sid = sessionStorage.getItem(SS_KEY);
    if (!sid) {
      sid = String(Date.now()) + '-' + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem(SS_KEY, sid);
    }
  } catch (e) {
    sid = 'nosession';
  }
  var state = { sid: sid, shown: 0, closed: false };
  try {
    var raw = localStorage.getItem(LS_KEY);
    if (raw) {
      var parsed = JSON.parse(raw);
      if (parsed && parsed.sid === sid) state = parsed;
    }
  } catch (e) { /* almacenamiento no disponible: se opera en memoria */ }
  if (state.closed || state.shown >= MAX_SHOWS) {
    host.remove();
    return;
  }
  function persist() {
    try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (e) {}
  }

  /* ---------- Utilidades ---------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    document.documentElement.classList.contains('rm');

  function hace(iso) {
    var s = Math.max(0, (Date.now() - Date.parse(iso)) / 1000);
    if (s < 90) return 'hace un momento';
    var m = Math.floor(s / 60);
    if (m < 60) return 'hace ' + m + ' min';
    var h = Math.floor(m / 60);
    if (h < 24) return 'hace ' + h + (h === 1 ? ' hora' : ' horas');
    var d = Math.floor(h / 24);
    if (d < 7) return 'hace ' + d + (d === 1 ? ' día' : ' días');
    if (d < 30) {
      var w = Math.floor(d / 7);
      return 'hace ' + w + (w === 1 ? ' semana' : ' semanas');
    }
    if (d < 365) {
      var mo = Math.floor(d / 30);
      return 'hace ' + mo + (mo === 1 ? ' mes' : ' meses');
    }
    var y = Math.floor(d / 365);
    return 'hace ' + y + (y === 1 ? ' año' : ' años');
  }

  /* ---------- Construcción de la tarjeta ---------- */
  var card = document.createElement('div');
  card.className = 'fnx-proof-card';
  card.setAttribute('role', 'status');

  var img = document.createElement('img');
  img.className = 'fnx-proof-img';
  img.alt = '';
  img.loading = 'lazy';
  img.width = 52;
  img.height = 52;

  var text = document.createElement('div');
  text.className = 'fnx-proof-text';
  var line = document.createElement('span');
  line.className = 'fnx-proof-product';
  var strong = document.createElement('strong');
  var rest = document.createElement('span');
  line.appendChild(strong);
  line.appendChild(rest);
  var when = document.createElement('span');
  when.className = 'fnx-proof-when';
  text.appendChild(line);
  text.appendChild(when);

  var closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'fnx-proof-close';
  closeBtn.setAttribute('aria-label', 'Cerrar aviso');
  closeBtn.textContent = '✕';

  card.appendChild(img);
  card.appendChild(text);
  card.appendChild(closeBtn);

  var current = null;
  card.addEventListener('click', function (ev) {
    if (ev.target === closeBtn) return;
    if (current && current.url) window.location.href = current.url;
  });
  closeBtn.addEventListener('click', function (ev) {
    ev.stopPropagation();
    state.closed = true;
    persist();
    hideCard();
    stop();
    host.remove();
  });

  function fill(entry) {
    current = entry;
    strong.textContent = entry.name;
    rest.textContent = (entry.state ? ' · ' + entry.state : '') + ' compró ' + entry.product;
    when.textContent = hace(entry.date);
    if (entry.image) {
      img.src = entry.image;
      img.style.display = '';
    } else {
      img.removeAttribute('src');
      img.style.display = 'none';
    }
  }

  function showCard() {
    if (!card.isConnected) host.appendChild(card);
    // Fuerza el estado inicial para que la transición se reproduzca
    card.classList.remove('is-in');
    void card.offsetWidth;
    card.classList.add('is-in');
  }

  function hideCard() {
    card.classList.remove('is-in');
  }

  /* ---------- Motor de tiempos (solo avanza con la pestaña visible) ---------- */
  var FIRST_DELAY = 16000;   // ~16 s
  var SHOW_TIME = 6500;      // visible por tarjeta
  var GAP_TIME = 14000;      // pausa entre tarjetas
  var TICK = 250;

  var phase = 'wait';        // wait -> showing -> gap -> showing ...
  var elapsed = 0;
  var phaseTarget = FIRST_DELAY;
  var idx = Math.floor(Math.random() * feed.length); // arranque rotado por sesión
  var timer = null;
  var stopped = false;

  // En ficha de producto móvil: no arrancar hasta que el visitante haga scroll,
  // para no competir con la buybar pegajosa al aterrizar en la página.
  var scrollGate = document.body.classList.contains('tpl-product') && window.innerWidth < 750;
  var gateOpen = !scrollGate;
  if (scrollGate) {
    var onScroll = function () {
      if (window.scrollY > 260) {
        gateOpen = true;
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function stop() {
    stopped = true;
    if (timer) window.clearInterval(timer);
    timer = null;
  }

  function tick() {
    if (stopped) return;
    if (document.visibilityState !== 'visible') return; // reloj en pausa
    if (!gateOpen) return;
    elapsed += TICK;
    if (elapsed < phaseTarget) return;
    elapsed = 0;
    if (phase === 'wait' || phase === 'gap') {
      if (state.shown >= MAX_SHOWS || state.closed) { stop(); return; }
      fill(feed[idx % feed.length]);
      idx += 1;
      state.shown += 1;
      persist();
      showCard();
      phase = 'showing';
      phaseTarget = SHOW_TIME;
    } else if (phase === 'showing') {
      hideCard();
      if (state.shown >= MAX_SHOWS) { stop(); return; }
      phase = 'gap';
      phaseTarget = GAP_TIME;
    }
  }

  document.addEventListener('visibilitychange', function () {
    // Al ocultar la pestaña durante una tarjeta, se retira (ya contó como vista)
    if (document.visibilityState === 'hidden' && phase === 'showing') {
      hideCard();
      elapsed = 0;
      if (state.shown >= MAX_SHOWS) { stop(); return; }
      phase = 'gap';
      phaseTarget = GAP_TIME;
    }
  });

  timer = window.setInterval(tick, TICK);
})();
